import { useEffect } from 'react'
import { useParams } from 'react-router'
import { useAIAssistantStore } from '#src/hooks/useAIAssistantStore.ts'

/*
 * Syncs the current patient from the URL to the AI assistant store.
 * Clears context when navigating away from a patient.
 *
 * Every resource page that sets `resourceRef` also clears it on unmount, so
 * this app-level effect must leave the field alone while a patient is in
 * scope: it runs in the same commit as the page that just set it, and React
 * flushes child passive effects first, so clearing here would land last and
 * strand the assistant with no resource in scope.
 */
export function useAIAssistantPatientSync(): void {
  const patientId = useParams().patientId ?? null
  const setPatientId = useAIAssistantStore((state) => state.setPatientId)
  const clearContext = useAIAssistantStore((state) => state.clearContext)
  const clearResourceContext = useAIAssistantStore(
    (state) => state.clearResourceContext
  )
  useEffect(() => {
    setPatientId(patientId)
    if (!patientId) {
      clearContext()
      clearResourceContext()
    }
  }, [patientId, setPatientId, clearContext, clearResourceContext])
}
